export enum InvitationType {
  joinHub = 'join_hub',
  joinLearnspace = 'join_learnspace',
  requestAccessLearnspace = 'requestaccess_learnspace'
}
